/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_RefreshInputs */

const en_roster_refresh = /** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh roster`)
};

const es_roster_refresh = /** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar lista`)
};

const fr_roster_refresh = /** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser la liste`)
};

const de_roster_refresh = /** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste aktualisieren`)
};

const id_roster_refresh = /** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segarkan daftar hadir`)
};

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const ja_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const zh_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const ar_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const it_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const ru_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const pt_roster_refresh = en_roster_refresh;

/** @type {(inputs: Roster_RefreshInputs) => LocalizedString} */
const ko_roster_refresh = en_roster_refresh;

/**
* | output |
* | --- |
* | "Refresh roster" |
*
* @param {Roster_RefreshInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_refresh = /** @type {((inputs?: Roster_RefreshInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_RefreshInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_refresh(inputs)
	if (locale === "es") return es_roster_refresh(inputs)
	if (locale === "fr") return fr_roster_refresh(inputs)
	if (locale === "de") return de_roster_refresh(inputs)
	if (locale === "ja") return ja_roster_refresh(inputs)
	if (locale === "zh") return zh_roster_refresh(inputs)
	if (locale === "ar") return ar_roster_refresh(inputs)
	if (locale === "id") return id_roster_refresh(inputs)
	if (locale === "it") return it_roster_refresh(inputs)
	if (locale === "ru") return ru_roster_refresh(inputs)
	if (locale === "pt") return pt_roster_refresh(inputs)
	return ko_roster_refresh(inputs)
});